import Router from "./navigation/Router";


export default function App() {
  return <Router />;
}
